import React, { useContext, useEffect } from 'react';
import { Flex } from '@balance-web/flex';
import { LoadingDots } from '@balance-web/loading';

import { IdContext } from '../context';
import { Layout } from '../components/layout';
import { useNavigationWithQuery } from '../components/authentication/useNavigationWithQuery';
import { useAuth } from '../context/useAuth';

const Index = () => {
  const { tenancy: TENANCY, product } = useContext(IdContext);

  const { user } = useAuth();

  const { navigateTo } = useNavigationWithQuery();

  useEffect(() => {
    if (!user) {
      navigateTo({ path: 'login' });
    }
  });

  return (
    <Layout product={product} theme={TENANCY}>
      <Flex alignItems="center" height="100vh" justifyContent="center">
        <LoadingDots label="Loading" />
      </Flex>
    </Layout>
  );
};

export default Index;
